// @module C3.ShoppingExtensions.PLP
define('C3.ShoppingExtensions.ReceiveUpdates.OptOut.View'
,	[
	'c3_shoppingextensions_receiveupdates_opt_out.tpl'
	
	//,	'C3.ShoppingExtensions.PLP.SS2Model'
	
	,	'Backbone'
    ]
, function (
	c3_shoppingextensions_receiveupdates_opt_out_tpl
	
	//,	PLPSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class C3.ShoppingExtensions.PLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_receiveupdates_opt_out_tpl

	,	initialize: function (options) {

			var currentUrl = typeof window !== 'undefined' ? window.location.href : ''
			this.UnqSubCode = ''
			this.ruRID = ''

			if(currentUrl.indexOf('?token=') > -1)
			{
				var splitInfo = currentUrl.split('?token=')
				//console.log(splitInfo)
				if(splitInfo && splitInfo[1])
				{
					this.UnqSubCode = splitInfo[1]
				}
				//console.log(this.UnqSubCode)
			}	
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

	,   render: function()
		{
			  var UnqSubCode = this.UnqSubCode
			  ,   self = this;
			  jQuery.ajax({
			        url : '/app/site/hosting/scriptlet.nl?script=2533&deploy=1&action=FETCH&UnqSubCode='+UnqSubCode,
			        type: "GET",
			        async: true,
			        success: function(data) {
			          var parseResponse = JSON.parse(data)
			          console.log(parseResponse)
			          if(parseResponse.status == "success"){
			          	self.ruRID = parseResponse.receiveUpdate_RecIID
			          	self.itemName = parseResponse.itemDisplayName
			          	self._render();
			          }
			          else
			          {
			          	self._render();
			          }
			        },
			        error: function (jqXHR, textStatus, errorThrown) {
			            console.log(jqXHR);
			            self._render();
			        }
			    });

			/*this._render();*/
		}		

		//@method getContext @return C3.ShoppingExtensions.PLP.View.Context
	,	getContext: function getContext()
		{
			console.log(this.UnqSubCode)
			
			return {
				UnqSubCode : this.UnqSubCode,
				hasUnqSubCode : this.UnqSubCode !== '' ? true : false,
				hasRecID : this.ruRID !== '' ? true : false,
				recID : this.ruRID,
				itemName : this.itemName
			};
		}
	});
});
